package org.hs_soft.runmynesto.pages.home.sub_page.user.component.tabs.rights_tab

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.user.UserCancellationReasonEnum
import org.hs_soft.runmynesto.domain.model.home.user.single_user.GetUser
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomTextArea
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.LineStyle


@Composable
fun UserRightsTabContent(
    onCancellationReasonClick: (dynamic) -> Unit,
    cancellationReason: UserCancellationReasonEnum,
    waiterCastleValue:String,
    onWaiterCastleFocusOut:(String)->Unit,
    updateDayEndCheck: (Boolean) -> Unit,
    updateTimeTracking:(Boolean)->Unit,
    updateIsAdmin:(Boolean)->Unit,
    updateIsViewSale:(Boolean)->Unit,
    updateIsManager:(Boolean)->Unit,
    updateInterimFinancialStatement:(Boolean)->Unit,
    selectedUser: GetUser?,
    windowSizeEnum: WindowSizeModeEnum,
) {
    Column(
        modifier = Modifier
            .showContentInOnePage()
            .fillMaxWidth()
            .padding(
                bottom =  Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    ) {

        MediumContentTitle(
            title = Strings.current().general,
            marginBottom = Dimen.mediumPadding,
        )

        if (windowSizeEnum== WindowSizeModeEnum.Desktop)
        {
            Row(modifier = Modifier.autoResponsiveness())
            {
                LeftSideUserRightContent(
                    cancellationReason=cancellationReason,
                    onCancellationReasonClick={
                        onCancellationReasonClick(it)
                    },
                    selectedUser=selectedUser,
                    updateTimeTracking= {
                        updateTimeTracking(it)
                    },
                    updateInterimFinancialStatement= {
                        updateInterimFinancialStatement(it)
                    },
                    updateDayEndCheck={
                        updateDayEndCheck(it)
                    },
                    updateIsAdmin= {
                        updateIsAdmin(it)
                    },
                    updateIsManager= {
                        updateIsManager(it)
                    },
                    updateIsViewSale= {
                        updateIsViewSale(it)
                    }
                )


                waiterCastleTextArea(
                    onFocusOut = {
                        onWaiterCastleFocusOut(it)
                    },
                    value =waiterCastleValue,
                    onValueChange = {

                    }
                )



            }
        }else{
            Column(
                modifier = Modifier
            ) {

                LeftSideUserRightContent(
                    cancellationReason=cancellationReason,
                    onCancellationReasonClick={
                        onCancellationReasonClick(it)
                    },
                    selectedUser=selectedUser,
                    updateTimeTracking= {
                        updateTimeTracking(it)
                    },
                    updateInterimFinancialStatement= {
                        updateInterimFinancialStatement(it)
                    },
                    updateDayEndCheck={
                        updateDayEndCheck(it)
                    },
                    updateIsAdmin= {
                        updateIsAdmin(it)
                    },
                    updateIsManager= {
                        updateIsManager(it)
                    },
                    updateIsViewSale= {
                        updateIsViewSale(it)
                    }
                )

                waiterCastleTextArea(
                    value =waiterCastleValue,
                    onValueChange = {},
                    onFocusOut = {
                        onWaiterCastleFocusOut(it)
                    },
                )
            }
        }
    }


}

@Composable
private fun waiterCastleTextArea(
    onFocusOut:(String)->Unit,
    value:String,
    onValueChange:(String)->Unit,
)
{
    CustomTextArea(
        label = Strings.current().waitersCastle,
        value =value,
        onFocusOut ={
            onFocusOut(it)
        }
    ) {
        onValueChange(it)
    }

}



@Composable
private fun LeftSideUserRightContent(
    cancellationReason: UserCancellationReasonEnum,
    onCancellationReasonClick: (dynamic) -> Unit,
    selectedUser: GetUser?,
    updateTimeTracking: (Boolean) -> Unit,
    updateInterimFinancialStatement: (Boolean) -> Unit,
    updateDayEndCheck: (Boolean) -> Unit,
    updateIsAdmin: (Boolean) -> Unit,
    updateIsManager: (Boolean) -> Unit,
    updateIsViewSale: (Boolean) -> Unit
) {
    Column(
        modifier = Modifier.
        margin(
            right = Dimen.mediumPadding,
            bottom = Dimen.mediumPadding,
        ))
    {
        DropDownItem(
            modifier = Modifier.margin(bottom = Dimen.mediumPadding),
            options = UserCancellationReasonEnum.entries,
            label = Strings.current().cancellationRight,
            selectedItem = UserCancellationReasonEnum.fromDisplayName(cancellationReason.title)
                ?: UserCancellationReasonEnum.NO_AUTHORIZATION,
            displayText = {
                if (it is UserCancellationReasonEnum)
                    it.title else ""
            },
            onOptionClick = {
                  onCancellationReasonClick(it)
            },
        )


        CheckboxComponent(
            modifier = Modifier
                .margin(
                    top = Dimen.mediumPadding,
                ),
            checkStatus = selectedUser?.isTimeTracking ?: false,
            title = Strings.current().enableUsersOnlyForTimeTracking,
            accentColor = Theme.PrimaryMain.rgb,
            onChecked = {
                updateTimeTracking(true)
            },
            onUnChecked = {
                updateTimeTracking(false)
            },
        )

//        CheckboxComponent(
//            modifier = Modifier
//                .margin(top = Dimen.mediumPadding),
//            checkStatus = selectedUser?.isFinStatements ?: false,
//            title = Strings.current().interimFinancialStatement,
//            onChecked = {
//                updateInterimFinancialStatement(true)
//            },
//            onUnChecked = {
//                updateInterimFinancialStatement(false)
//            },
//            accentColor = Theme.Blue.rgb
//        )

        CheckboxComponent(
            modifier = Modifier
                .margin(top = Dimen.mediumPadding),
            checkStatus = selectedUser?.isDayFinStatements ?: false,
            title = Strings.current().DAYS_END,
            onChecked = {
                updateDayEndCheck(true)
            },
            onUnChecked = {
                updateDayEndCheck(false)
            },
            accentColor = Theme.PrimaryMain.rgb
        )

        CheckboxComponent(
            modifier = Modifier
                .margin(
                    top = Dimen.mediumPadding,
                    bottom = Dimen.mediumPadding,
                ),
            checkStatus = selectedUser?.isAdmin ?: false,
            title = Strings.current().ADMINISTRATOR,
            onChecked = {
                updateIsAdmin(true)
            },
            onUnChecked = {
                updateIsAdmin(false)
            },
            accentColor = Theme.PrimaryMain.rgb
        )

        MediumContentTitle(
            title = Strings.current().gastronomy,
            marginTop = Dimen.mediumPadding,
            marginBottom = Dimen.mediumPadding,
        )



        CheckboxComponent(
            modifier = Modifier,
            checkStatus = selectedUser?.isManager ?: false,
            title = Strings.current().MANAGER,
            onChecked = {
                updateIsManager(true)
            },
            onUnChecked = {
                updateIsManager(false)
            },
            accentColor = Theme.PrimaryMain.rgb
        )

        CheckboxComponent(
            modifier = Modifier
                .margin(
                    top = Dimen.mediumPadding,
                ),
            checkStatus = selectedUser?.isViewSales ?: false,
            title = Strings.current().NO_SALES_TRIGGER,
            onChecked = {
                updateIsViewSale(true)
            },
            onUnChecked = {
                updateIsViewSale(false)
            },
            accentColor = Theme.PrimaryMain.rgb
        )
    }

}
